"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
var _notice = require("@/api/basic/notice");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _tieTuNumber = _interopRequireDefault(require("@/api/activity/tieTuNumber.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tieTuActAdd',
  emits: ['saved'],
  props: {
    actId: {
      type: String,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId) {
        this.fetchCoupons('');
        if (newId && newId !== '' && newId !== 'null') {
          this.fetchActDetail(newId);
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      resPath: process.env.VUE_APP_IMAGE_PATH,
      fileList: [],
      time: null,
      couponLoading: false,
      couponOptions: [],
      form: {
        id: '',
        activityName: '',
        activityTitle: '',
        status: 0,
        startTime: '',
        endTime: '',
        ruleText: '',
        limitCount: 1,
        bgImage: '',
        rewardType: 1,
        rewardCouponId: null,
        rewardPoints: null,
        isQw: 0,
        isMember: 0,
        gradeId: [],
        topic: '',
        recommendPath: '',
        recommendTitle: ''
      },
      rules: {
        activityName: [{
          required: true,
          message: '请填写活动名称',
          trigger: 'blur'
        }],
        rewardType: [{
          required: true,
          message: '请选择奖励类型',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    fetchCoupons: function fetchCoupons(query) {
      var _this = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || ''
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this.couponOptions = res.records || [];
      }).finally(function () {
        _this.couponLoading = false;
      });
    },
    handleCustomUpload: function handleCustomUpload(_ref) {
      var _this2 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', '/tieTuNumber/');
      (0, _notice.uploadPhoto)(formData).then(function (res) {
        var url = _this2.resPath + res.data;
        _this2.form.bgImage = url;
        _this2.fileList = [{
          name: '背景图',
          url: url
        }];
        _this2.$message.success('上传成功');
      });
    },
    handleUploadRemove: function handleUploadRemove() {
      this.fileList = [];
      this.form.bgImage = '';
    },
    fetchActDetail: function fetchActDetail(id) {
      var _this3 = this;
      this.loading = true;
      _tieTuNumber.default.getDetail(id).then(function (res) {
        if (!res) return;
        _this3.form = {
          id: res.id || '',
          activityName: res.activityName || '',
          activityTitle: res.activityTitle || '',
          status: res.status != null ? res.status : 0,
          startTime: res.startTime || '',
          endTime: res.endTime || '',
          ruleText: res.ruleText || '',
          limitCount: res.limitCount || 1,
          bgImage: res.bgImage || '',
          rewardType: res.rewardType != null ? res.rewardType : 1,
          rewardCouponId: res.rewardCouponId || null,
          rewardPoints: res.rewardPoints || null,
          isQw: res.isQw != null ? Number(res.isQw) : 0,
          isMember: res.isMember != null ? Number(res.isMember) : 0,
          gradeId: res.gradeId ? res.gradeId.split(',').map(Number) : [],
          topic: res.topic || '',
          recommendPath: res.recommendPath || '',
          recommendTitle: res.recommendTitle || ''
        };
        if (res.startTime && res.endTime) {
          _this3.time = [res.startTime, res.endTime];
        }
        if (res.bgImage) {
          _this3.fileList = [{
            name: '背景图',
            url: res.bgImage
          }];
        }
      }).finally(function () {
        _this3.loading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        if (!_this4.time || _this4.time.length !== 2) {
          _this4.$message.error('请选择活动时间');
          return;
        }
        _this4.form.startTime = _this4.time[0];
        _this4.form.endTime = _this4.time[1];
        var payload = Object.assign({}, _this4.form);
        payload.isQw = 0;
        payload.isMember = 0;
        payload.gradeId = '';
        _this4.loading = true;
        _tieTuNumber.default.addAct(payload).then(function () {
          _this4.$message.success('保存成功');
          _this4.$emit('saved');
        }).finally(function () {
          _this4.loading = false;
        });
      });
    }
  }
};